import { useEffect, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { fetchTicketListSelectRows } from '../../../../lib/snapshotRows'
import { TicketListSelectRow } from '../model'

type UseTicketListSelectDataProps = {
  snapshotUuid: string
}

export const useTicketListSelectData = ({
  snapshotUuid,
}: UseTicketListSelectDataProps) => {
  const [rows, setRows] = useState<TicketListSelectRow[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const { fetchMasterScheduleTicketLists } = useProjectPlanSnapshotRepository()

  useEffect(() => {
    const cancelled = { current: false }
    setIsLoading(true)
    fetchTicketListSelectRows(snapshotUuid, fetchMasterScheduleTicketLists)
      .then(result => {
        if (!cancelled.current) setRows(result)
      })
      .catch(error => {
        // 失敗時のユーザー通知は共通API層(lib/commons/api)が行うため、ここでは状態のみ戻す
        console.error('Failed to fetch ticket list data:', error)
        if (!cancelled.current) setRows([])
      })
      .finally(() => {
        if (!cancelled.current) setIsLoading(false)
      })
    return () => {
      cancelled.current = true
    }
  }, [snapshotUuid, fetchMasterScheduleTicketLists])

  return { rows, isLoading }
}
